import { Site } from "src/app/types/Site";
import { KeywordsByDay, KeywordsByDayWithThematic } from "src/app/types/planning";
import { SimpleFormSelectOption } from "../../form/SimpleFormSelect";
import ResumeNetlinkingWithOptions from "./ResumeNetlinkingWithOptions";
import ResumeRanking from "./ResumeRanking";
import ResumeFilling from "./ResumeFilling";
import { ResumeNetlinking } from "./ResumeNetlinking";
import ResumeBoost from "./ResumeBoost";
import ResumeDiscover from "./ResumeDiscover";
import ResumeLead from "./ResumeLead";
export type TContentType =
    | "filling"
    | "ranking"
    | "netlinkingWithOptions"
    | "lead"
    | "boost"
    | "discover"
    | "netlinking";
export interface IResumeKeywords extends ICommonResumeKeywords {
    contentType?: TContentType;
}

export interface ICommonResumeKeywords {
    months?: number;
    moneySite?: Site;
    kwFilling?: Array<KeywordsByDay> | null;
    kwLead?: Array<KeywordsByDay> | null;
    kwBoost?: Array<KeywordsByDay> | null;
    kwDiscover?: Array<KeywordsByDay> | null;
    kwNetlinking?: Array<KeywordsByDayWithThematic & { id?: number }> | null | undefined;
    kwRanking?: Array<KeywordsByDay> | null;
    thematicsOptions?: SimpleFormSelectOption[];
    urlOptions?: Array<SimpleFormSelectOption & { contentType: string }>;
    handleKwNetlinking?(id: number, url: string): void;
}

const ResumeKeywords = (props: IResumeKeywords) => {
    const {
        months,
        moneySite,
        kwFilling,
        kwRanking,
        kwLead,
        kwBoost,
        kwDiscover,
        kwNetlinking,
        contentType,
        thematicsOptions,
        handleKwNetlinking,
        urlOptions,
    } = props;
    if (!contentType || !months || !moneySite) return <></>;
    return (
        <>
            {
                {
                    filling: kwFilling && (
                        <ResumeFilling
                            kwFilling={kwFilling}
                            moneySite={moneySite}
                            months={months}
                        />
                    ),
                    discover: kwDiscover && (
                        <ResumeDiscover
                            kwDiscover={kwDiscover}
                            moneySite={moneySite}
                            months={months}
                        />
                    ),
                    lead: kwLead && (
                        <ResumeLead kwLead={kwLead} moneySite={moneySite} months={months} />
                    ),
                    boost: kwBoost && (
                        <ResumeBoost kwBoost={kwBoost} moneySite={moneySite} months={months} />
                    ),
                    ranking: kwRanking && (
                        <ResumeRanking
                            kwRanking={kwRanking}
                            moneySite={moneySite}
                            months={months}
                        />
                    ),
                    netlinkingWithOptions: !!kwNetlinking &&
                        !!urlOptions &&
                        !!thematicsOptions &&
                        !!handleKwNetlinking && (
                            <ResumeNetlinkingWithOptions
                                handleKwNetlinking={handleKwNetlinking}
                                thematicsOptions={thematicsOptions}
                                kwNetlinking={kwNetlinking}
                                moneySite={moneySite}
                                months={months}
                                urlOptions={urlOptions}
                            />
                        ),
                    netlinking: !!kwNetlinking && !!thematicsOptions && (
                        <ResumeNetlinking
                            thematicsOptions={thematicsOptions}
                            kwNetlinking={kwNetlinking}
                            moneySite={moneySite}
                            months={months}
                        />
                    ),
                    default: <></>,
                }[contentType || "default"]
            }
        </>
    );
};
export default ResumeKeywords;
